export const MANUAL_ICE_MACHINE_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://everest.ind.br/pt#organization",
   "name": "Everest Refrigeração Indústria e Comércio",
   "url": "https://everest.ind.br/pt"
  },
  {
   "@type": "WebSite",
   "@id": "https://everest.ind.br/pt#website",
   "url": "https://everest.ind.br/pt",
   "name": "Everest | Purificadores e Máquinas de Gelo",
   "publisher": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "inLanguage": "pt-BR",
   "potentialAction": {
    "@type": "SearchAction",
    "target": "https://everest.ind.br/pt?s={search_term_string}",
    "query-input": "required name=search_term_string"
   }
  },
  {
   "@type": "WebPage",
   "@id": "https://everest.ind.br/pt/manual-maquinas-de-gelo#webpage",
   "url": "https://everest.ind.br/pt/manual-maquinas-de-gelo",
   "name": "Manual das Máquinas de Gelo Everest | Instruções de Uso",
   "description": "Acesse o manual de instruções das máquinas de gelo Everest: instalação, operação, limpeza e manutenção preventiva.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/pt#website"
   },
   "about": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "publisher": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/manual-maquinas-de-gelo#breadcrumb"
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/manual-maquinas-de-gelo#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/pt"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Manual",
     "item": "https://everest.ind.br/pt/manual-maquinas-de-gelo"
    }
   ]
  }
 ]
}
